import React, { useEffect } from "react";
import "./Myskill.css";
function Myskill() {
  useEffect(() => {
    document.title = "Pijush Ray Mondal || Sill and Tools";
  });
  return (
    <div className="myskill">
      <div className="skill-descripttion">
        <p className="skill-subtitle">SKILLS & TOOLS</p>
        <p className="skill-title">My Toolbox & Things I Can Do</p>
        <p className="skill-summery">
          The skills, tools and technologies I use to bring your products to
          life:
        </p>
      </div>
      <div className="skill-tools-item">
        <div className="skill-icon">
          <i class="fa-brands fa-html5 fa--custom--icon"></i>
          <p>html5</p>
        </div>
        <div className="skill-icon">
          <i class="fa-brands fa-css3 fa--custom--icon"></i>
          <p>css3</p>
        </div>
        <div className="skill-icon">
          <i class="fa-brands fa-js fa--custom--icon"></i>
          <p>javascript</p>
        </div>
        <div className="skill-icon">
          <i class="fa-brands fa-react fa--custom--icon"></i>
          <p>react</p>
        </div>
        <div className="skill-icon">
          <i class="fa-brands fa-github fa--custom--icon"></i>
          <p>github</p>
        </div>
        <div className="skill-icon">
          <i class="fa-brands fa-git-alt fa--custom--icon"></i>
          <p>git</p>
        </div>
        <div className="skill-icon">
          <i class="fa-solid fa-gears fa--custom--icon"></i>
          <p>Rest Api</p>
        </div>
        <div className="skill-icon">
          <i class="fa-solid fa-terminal fa--custom--icon"></i>
          <p>terminal</p>
        </div>
        <div className="skill-icon">
          <i class="fa-brands fa-bootstrap fa--custom--icon"></i>
          <p>bootstrap</p>
        </div>
      </div>
      <div className="skill-gist">
        <p className="gist-title">Currently working on:</p>
        <p className="gist-para">
          Improving my skills in, and understanding of vanilla JavaScript and
          React. Also, having fun with #100DaysOfCode building & animating
          things via CSS.
        </p>
      </div>
    </div>
  );
}

export default Myskill;
